// ManagerRoute.js
import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import { jwtDecode } from "jwt-decode";

const ManagerRoute = () => {
  const { jwtToken } = useContext(AuthContext);

  if (!jwtToken) {
    return <Navigate to="/login" />;
  }

  // Decode the JWT token to extract user info
  const decodedToken = jwtDecode(jwtToken);

  // Check if the user's role is 'manager'
  if (decodedToken.role !== "manager") {
    return <Navigate to="/unauthorized" />;
  }

  // If the user is a manager, allow access to the route
  return <Outlet />;
};

export default ManagerRoute;
